import * as z from "zod/v4";

export const updateWorkOrderFlows = {
  name: "updateWorkOrderFlows" as const,
  input: z.object({
    flows: z.array(
      z.object({
        id: z.string(),
        index: z.number().int(),
        enabled: z.boolean(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
